import { render, staticRenderFns } from "./ManageTeams.vue?vue&type=template&id=08d049cc"
import script from "./ManageTeams.vue?vue&type=script&lang=js"
export * from "./ManageTeams.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports